import React from 'react'

const AssignRequeriment = () => {
  return (
    <div>AssignRequeriment</div>
  )
}

export default AssignRequeriment